<script></script>

<div class="page">
  <h1 class="page-title">About</h1>

  <div class="statement">
    <p>
      I create architectural textile assemblages that investigate spatial
      relationships between constructed and natural environments. Based in
      Santa Fe, my works transform the ephemeral qualities of New Mexico&rsquo;s
      distinctive light and shadow into tactile compositions through precisely
      constructed canvas tapestries.
    </p>

    <p>
      My practice engages a conversation with interior/exterior space through
      a formal visual vocabulary of horizons, arches, and architectural
      constructions. By transforming transient elements like clouds and
      shadows into tactile objects, I materialize the immaterial, challenging
      conventional perceptions of permanence, and assumed roles. Cloud Play
      becomes a sarcastic inversion of roles, the soft dominating the rigid.
    </p>

    <p>
      My methodical process begins with sketching and digital modeling of my
      scenes, drafted to scale as pattern pieces, cut and stitched together,
      then stuffed with quilt batting for added dimension. Through these
      material investigations, I seek to create environments where
      architectural language opens into questions of presence, perception, and
      belonging within the contemporary landscape.
    </p>
  </div>
</div>

<style>
  .page {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2rem 2rem 10rem 2rem;
  }

  .page-title {
    font-family: "Cormorant Garamond", serif;
    font-weight: 400;
    font-size: 2.6rem;
    line-height: 1;
    color: #1a1a1a;
    margin: 1rem 0 1.5rem 0;
  }

  .statement {
    color: #222;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    font-size: 1.05rem;
    line-height: 1.8;
    max-width: 38rem;
  }
  p {
    margin: 0;
  }
</style>
